module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABWklEQVQ4ja2VsU4CQRCGPy5GKFRK34MKKwprKnMxSmljRXwE9g2EysYWNMQ3QBMru3sH3gDUAhLht+AnucidgjDJn92bmf0yu7c3V5CELQIugCugApT53cZAAtwDvRDCHKBgYBl4Ak6dPAc+/gAeugiAZ+AshDBGUiRpoIUNJcWSSpL4QyXnDr12IClCUiMFO14DlNa+1yyhDSS9+CHeEFaT9GlobMYLkkaSZjnbPJf0Jmlqvdm33HKt1Wot5zNJo8gv5AOY/Dj0NvAAVAFZVfvazn8FCCFMzChHZNs50ATegUvgwLq0r+mcFcsD3ni8BnrAl9WzL52zFrACTIF+RqzvWGUT4L8tD5gARSDOiMWOJZsAbz3esfi+96wL+9I5awEfgQ5wBHSBT6trX8c5q7bFxUYSWRc7caX1nEpPWJxZ0fOsyupmJNs2B7Kaw07b184b7BIIO/oFfAMukxjBJWA4iwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/imgs/instagram.png
// module id = 209
// module chunks = 0